import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

import { PrimaryButton } from './components/PrimaryButton';
import { StepHeader } from './components/StepHeader';
import { SingleFileUploader } from './SingleFileUploader';
import { SkillMosaicSkeleton } from './SkillMosaicSkeleton';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

const labels = {
    continue: 'Continue',
    headlineText: 'Please upload your CV.',
    subHeadlineText: `Share your role or attach your résumé to build your skills mosaic.`,
};

const SecondaryText = styled.p({
    color: '#9a9a98',
    fontFamily: "'FT Regola Neue'",
    fontSize: '0.75rem',
    fontWeight: 500,
});

export const ProvideYourDataStep: FunctionComponent = () => {
    const isCvAnalysisLoading = useCompanyOnboardingStore((state) => state.isCvAnalysisLoading);
    const uploadedCV = useCompanyOnboardingStore((state) => state.uploadedCV);
    const startCVAnalysis = useCompanyOnboardingStore((state) => state.startCVAnalysis);

    if (isCvAnalysisLoading) {
        return <SkillMosaicSkeleton />;
    }

    return (
        <Fragment>
            <StepHeader headlineText={labels.headlineText} subHeadlineText={labels.subHeadlineText} />
            <SingleFileUploader />
            <PrimaryButton disabled={uploadedCV.isNothing} onClick={startCVAnalysis}>
                {labels.continue}
            </PrimaryButton>
            <SecondaryText>How can I download my CV from LinkedIn or XING?</SecondaryText>
        </Fragment>
    );
};
